import React from 'react';
import createStyles from "@material-ui/core/styles/createStyles";
import DeleteIcon from "@material-ui/icons/Delete";
import FileCopy from "@material-ui/icons/FileCopy";
import IconButton from "@material-ui/core/IconButton";
import SendIcon from "@material-ui/icons/Send";
import Tooltip from "@material-ui/core/Tooltip";
import withStyles, {WithStyles} from "@material-ui/core/styles/withStyles";

const styles = () => createStyles({
  actionsContainer: {
    marginLeft: '5px',
  },
});

interface Params {
  label: string; // user friendly label for an element such as a radio button
  value: string; // actual param value e.g.(copy=true)
}

export interface Action {
  title: string;
  icon: any;
  isActionDisabled: boolean; // for icon button to open dialog
  isSubmitDisabled: boolean; // for submit button in dialog
  matchText: string | null; // for adding confirmation text
  urlParams: Array<Params> | null;
}

export const Copy: Action = {
  title: "Copy",
  icon: <FileCopy fontSize="small" />,
  isActionDisabled: true,
  isSubmitDisabled: false,
  matchText: null,
  urlParams: null
};

export const Move: Action = {
  title: 'Move',
  icon: <SendIcon fontSize="small" />,
  isActionDisabled: true,
  isSubmitDisabled: true,
  matchText: null,
  urlParams: null
};

export const Delete: Action = {
  title: 'Delete',
  icon: <DeleteIcon fontSize="small" />,
  isActionDisabled: true,
  isSubmitDisabled: true,
  matchText: "Yes",
  urlParams: null
};

export interface ActionButtonsProps extends WithStyles<typeof styles> {
  actions: Array<Action>;
  openActionDialog: (string: string) => void;
}

const ActionButtons = (props: ActionButtonsProps) => {
  const { actions, classes, openActionDialog } = props;
  return (
    <div className={classes.actionsContainer}>
      {
        actions.map((action: Action) => (
          <Tooltip
            title={action.isActionDisabled ? '' : action.title}
          >
            <IconButton
              onClick={() => openActionDialog(`${action.title}`)}
              disabled={action.isActionDisabled}
            >
              {action.icon}
            </IconButton>
          </Tooltip>
        ))
      }
    </div>
  );
};

export default withStyles(styles)(ActionButtons);
